import HeaderView from "../HeaderView/HeaderView";
import QRCode from "react-qr-code"
import './QrCodeView.css'
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import React, {Dispatch, SetStateAction, useContext, useEffect} from "react";
import {
    Envelope,
    GearWideConnected, HourglassBottom,
    Icon1Circle,
    Icon2Circle,
    Icon3Circle,
    Icon4Circle, Robot,
    ThreeDotsVertical, Whatsapp
} from "react-bootstrap-icons";
import {Api, ApiAuthentication} from "../../RequestsProvider/RequestProvider";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
interface Props {
    apiCredentials: ApiAuthentication | null
    setApiCredentials: Dispatch<SetStateAction<ApiAuthentication | null>>
}

export const QrCodeView = ({apiCredentials, setApiCredentials}: Props) => {


    const request = useContext(Api)


    useEffect(() => {
        const getApiKeyInterval = setInterval(() => getApiKeyInformation().then(apiCredentials => {
            setApiCredentials(apiCredentials.message)
        }), 2000)
        return () => clearInterval(getApiKeyInterval)
    }, [])

    if (!request) {
        return (<></>)
    }

    const {getApiKeyInformation} = request

    const renderTooltipBotReady = (props:any) => (
        <Tooltip id="button-renderTooltipBotReady" {...props}>
            Bot bereit
        </Tooltip>
    );
    const renderTooltipEmailVerified = (props:any) => (
        <Tooltip id="button-renderTooltipEmailVerified" {...props}>
            E-Mail verifiziert
        </Tooltip>
    );
    const renderTooltipEnablingBot = (props:any) => (
        <Tooltip id="button-renderTooltipEnablingBot" {...props}>
            Bot wird vorbereitet
        </Tooltip>
    );

    let status = {
        emailVerified: apiCredentials?.emailVerified,
        prepareBot: !!apiCredentials?.qrCode,
        botReady: apiCredentials?.isAuthenticated === "true"
    }


    return (
        apiCredentials ? (<>
            <HeaderView/>
            <HeadNavigation path={[{path: "/", pathName: "Startseite"}, {path: null, pathName: "WhatsApp verbinden"}]}/>
            <div className="grid-padding">
                <div className="site-header d-flex justify-content-between align-items-center">
                    <h1>WhatsAppBot <span>[{!apiCredentials.emailVerified? 'warte auf E-Mail Verifizierung':apiCredentials.qrCode? 'verbinden' : 'warte auf QR-Code...'}]</span></h1>
                </div>

            </div>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 col-lg-6 d-flex justify-content-center">
                        <div className="progresses pb-3">


                            <OverlayTrigger
                                placement="top"
                                overlay={renderTooltipEmailVerified}>
                                <div className={`steps pointer ${status.emailVerified ? 'done' : null}`}>
                                    <span><Envelope/></span>
                                </div>
                            </OverlayTrigger>

                        <span className={`line ${status.emailVerified ? 'done' : null}`}></span>

                            <OverlayTrigger
                                placement="top"
                                overlay={renderTooltipEnablingBot}>
                                <div className={`steps pointer ${status.prepareBot ? 'done' : null}`}>
                                    <span><HourglassBottom/></span>
                                </div>
                            </OverlayTrigger>

                        <span className={`line ${status.prepareBot ? 'done' : null}`}></span>
                            <OverlayTrigger
                                placement="top"
                                overlay={renderTooltipBotReady}>
                                <div className={`steps pointer ${status.botReady ? 'done' : null}`}>
                                    <span><Robot/></span>
                                </div>
                            </OverlayTrigger>

                        </div>
                    </div>
                </div>
                <div className="row p-3">
                    <div className="col-12 col-lg-6">
                        <div className={`row ${!status.prepareBot?'text-not-active':''}`}>
                            <div className="col-12 mb-2">
                                Scanne den QR-Code, um den Bot mit deinem WhatsApp zu verbinden.
                            </div>
                            <div className="col-12 mb-2">
                                <div className="row">
                                    <div className="col-1"><Icon1Circle className={`m-3 text-green`}/></div>
                                    <div className="col-9 align-content-center">Öffne WhatsApp <Whatsapp
                                        className={`text-green mb-2`}/> auf deinem Telefon.
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <div className="row">
                                    <div className="col-1"><Icon2Circle className={`m-3 text-green`}/></div>
                                    <div className="col-9 align-content-center">Tippe auf einem Android-Gerät auf
                                        Menü <ThreeDotsVertical className={`text-muted border bg-secondary-subtle`}/>,
                                        oder auf einem iPhone auf Einstellungen <GearWideConnected
                                            className={`text-muted border bg-secondary-subtle`}/>.
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <div className="row">
                                    <div className="col-1"><Icon3Circle className={`m-3 text-green`}/></div>
                                    <div className="col-9 align-content-center">Tippe auf Verknüpfte Geräte und dann auf
                                        Gerät hinzufügen.
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-1"><Icon4Circle className={`m-3 text-green`}/></div>
                                    <div className="col-9 align-content-center">Scanne zur Bestätigung den QR-Code.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mt-4 mt-lg-0">
                        {apiCredentials.qrCode ? <QRCode
                                size={256}
                                fgColor={'#ffffff'}
                                bgColor={'#000000'}
                                value={apiCredentials.qrCode}
                            />
                            :
                            <div className="loader_wrapper border bg-body-secondary">
                                <svg className="loader" width="65" height="65" viewBox="0 0 44 44">
                                    <circle cx="22" cy="22" r="20" fill="none" strokeWidth="4"></circle>
                                </svg>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>) : null
    )
}